export default __webpack_public_path__ + "static/media/1735.768b78c5.png";